import { FC, useState } from 'react';
// Hooks
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Models
import IAnswer, { IAnswerResult } from 'models/Answer';
// Actions
import { setAnswers, setQuestionEnd, setQuestionStart } from 'store/player/playerSlice';
// Selectors
import { selectQuestion } from 'store/quiz/quizSelectors';
// Component
import { Button } from 'components/Buttons';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  answers: IAnswer[];
  disabled?: boolean;
  score: number;
  time: number;
};

const MultiAnswer:FC<Props> = ({ answers, disabled = false, score, time }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const question = useAppSelector(selectQuestion);

  const [ clicked, setClicked ] = useState(false);
  const [ selectedAnswers, setSelectedAnswers ] = useState<string[]>([]);

  const handleClick = (ref: string) => {
    setSelectedAnswers(prev => {
      if (selectedAnswers.includes(ref)) {
        return prev.filter(answerRef => answerRef !== ref);
      } else {
        return [...prev, ref];
      }
    })
  }

  const handleSubmit = () => {
    if(clicked) return;

    dispatch(setQuestionStart(false));

    const nextAnswers = answers.reduce((acc: IAnswerResult[], cur: IAnswer) => {
      if (selectedAnswers.includes(cur.ref)) {
        acc.push({
          ref: cur.ref,
          title: cur.title,
          score,
          time,
          question: {
            ref: question.ref,
            title: question.title
          }
        })
      }
      return acc;
    }, [])

    dispatch(setAnswers(nextAnswers));
    dispatch(setQuestionEnd(true));

    setClicked(true);
  }

  return (
    <>
      {answers.map(answer => (
        <Button
          key={answer.ref}
          className={`
            ${selectedAnswers.some(answerRef => answerRef === answer.ref)
              ? 'selected-answer-button'
              : 'bg-linear'
            }
            normal-case font-bold
          `}
          onClick={() => handleClick(answer.ref)}
          disabled={disabled || clicked}
        >
          <span className={disabled ? 'blur-sm  select-none' : ''}>{answer.title}</span>
        </Button>
      ))}
      <Button
        className="w-full text-xl uppercase primary-button"
        onClick={handleSubmit}
        disabled={!selectedAnswers.length || clicked}
      >
        {t('buttons.next')}
      </Button>
    </>
  )
}

export default MultiAnswer;
